import { createSlice } from "@reduxjs/toolkit";

const wavierSlice = createSlice({
  name: "wavier",
  initialState: {
    Parent: {
      firstName: "",
      lastName: "",
      email: "",
      DOB: null,
      phoneNumber: "",
      address: "",
      city: "",
      state: "",
      zipcode: "",
      steps: [],
      signature: "",
    },
  },
  reducers: {
    updateWaiver: (state, action) => {
      state.Parent = { ...action.payload };
    },
    updateSingature: (state, action) => {
      state.Parent = {
        ...state.Parent,
        signature: action.payload,
      };
    },
    resetWaiver: (state) => {
      state.Parent = {
        firstName: "",
        lastName: "",
        email: "",
        DOB: null,
        phoneNumber: "",
        address: "",
        city: "",
        state: "",
        zipCode: "",
        steps: [],
        signature: "",
      };
    },
  },
});

export const { updateWaiver, updateSingature, resetWaiver, updateStep } =
  wavierSlice.actions;
export default wavierSlice.reducer;
